import { sendEmailVerificationLink } from '@libraries/firebase';
import { logError } from '@reporting';
import { Anchor, Card, NoticeTitle, Section } from '@shared';
import { User } from 'firebase/auth';
import { useState } from 'react';
import styled from 'styled-components';

const VerifyEmailMessageWrapper = styled.div`
  padding: 1rem;
  text-align: center;

  em {
    font-style: normal;
    font-weight: ${(props) => props.theme.fontWeightBold};
  }
`;

const VerifyEmailPageWrapper = styled.div`
  text-align: center;
`;

interface Props {
  redirectTo: string;
  user: User;
}

export function VerifyEmailMessage({ redirectTo, user }: Props) {
  const [sent, setSent] = useState(false);

  function handleSendLink() {
    sendEmailVerificationLink(user, redirectTo, logError, () => {});
    setSent(true);
  }

  if (sent) {
    return (
      <VerifyEmailMessageWrapper>
        Another verification email has been sent. Please check your mailbox in a
        few minutes.
      </VerifyEmailMessageWrapper>
    );
  }

  return (
    <VerifyEmailMessageWrapper>
      A verification email has been sent to <em>{user?.email}</em>.{' '}
      <Anchor href="#?" onClick={handleSendLink}>
        Click here to send another
      </Anchor>
      .
    </VerifyEmailMessageWrapper>
  );
}

export function VerifyEmailPage(props: Props) {
  return (
    <Section justifyContent="center">
      <VerifyEmailPageWrapper>
        <Card>
          <NoticeTitle>Please verify your account.</NoticeTitle>
          <VerifyEmailMessage {...props} />
        </Card>
      </VerifyEmailPageWrapper>
    </Section>
  );
}
